import type { SimulacaoMarcaTagProps } from "./types-simulacao-marca";
import { useSimulacaoMarca } from "./use-simulacao-marca";
import { SimulacaoMarcaTagView } from "./view-simulacao-marca";

export { SIMULACAO_MARCA_CLASSES } from "./simulacao-marca.classes";

/**
 * Selo "Simulado" (Figma 9287:670) da linha alterada. O tooltip é o cartão rico do Figma
 * (10892:402): obra, recurso, anterior → novo e período.
 */
export function SimulacaoMarcaTag(props: SimulacaoMarcaTagProps) {
  const vm = useSimulacaoMarca(props);

  return <SimulacaoMarcaTagView {...vm} />;
}

export type * from "./types-simulacao-marca";
